/**
 * @param marker {PropertyMarker}
 * @returns {string}
 */

import * as markerIcon from '../../icons/marker.svg';

export function simplePropertyMarkerTemplateIcon(marker) {
    return ` <img src="${markerIcon}" alt="marker" class="property-marker-icon marker-icon">
             <span class="property-marker-icon-dot"></span>
            `;
}
